function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "28",
  height: "28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1458_185)",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.505 9.331H3.495M20.42 15.167a5.252 5.252 0 110 10.505 5.252 5.252 0 010-10.505"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.12 24.504H6.997a3.501 3.501 0 01-3.501-3.501V6.997a3.501 3.501 0 013.501-3.501h14.006a3.501 3.501 0 013.502 3.501V17.12M20.678 17.84v2.79M18.405 20.63h2.273M7.93 13.416a.058.058 0 11-.059-.058M7.871 13.358c.033 0 .059.026.059.058M12.016 13.416a.058.058 0 11-.058-.058M11.958 13.358c.032 0 .058.026.058.058M7.93 16.918a.058.058 0 11-.059-.059M7.871 16.86c.033 0 .059.026.059.058M12.016 16.918a.058.058 0 11-.058-.059M11.958 16.86c.032 0 .058.026.058.058M16.1 13.416a.058.058 0 11-.058-.058M16.041 13.358c.033 0 .059.026.059.058M7.93 20.42a.058.058 0 11-.059-.06M7.871 20.361c.033 0 .059.026.059.058M12.016 20.42a.058.058 0 11-.058-.06M11.958 20.361c.032 0 .058.026.058.058"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1458_185"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h28v28H0z"
}))));